import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgV2ItemCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "17px",
	height: "17px",
	viewBox: "0 0 17 17",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "dib_checklist_Revised_07_04_No-Filling",
			transform: "translate(-1253.000000, -789.000000)",
			fill: "currentColor",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("g", {
				id: "TitleCollapsed",
				transform: "translate(426.000000, 781.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Action-Buttons",
					transform: "translate(819.350515, 0.000000)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M12.4916667,14.5083333 L11.2083333,15.7916667 L15.3333333,19.9166667 L24.5,10.75 L23.2166667,9.46666667 L15.3333333,17.35 L12.4916667,14.5083333 Z M22.6666667,22.6666667 L9.83333333,22.6666667 L9.83333333,9.83333333 L19,9.83333333 L19,8 L9.83333333,8 C8.825,8 8,8.825 8,9.83333333 L8,22.6666667 C8,23.675 8.825,24.5 9.83333333,24.5 L22.6666667,24.5 C23.675,24.5 24.5,23.675 24.5,22.6666667 L24.5,15.3333333 L22.6666667,15.3333333 L22.6666667,22.6666667 Z",
						id: "Shape"
					})
				})
			})
		})
	})
});
export default SvgV2ItemCheck;
